import CircleEmptyInfoIcon from "../images/CircleEmptyInfoIcon.mjs";

/**
 * App icon for Info
 * @see {GlyphIcon}
 * @see {CircleEmptyInfoIcon}
 */
const AppInfoIcon = class extends CircleEmptyInfoIcon {}

export default AppInfoIcon;